import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { OpenClientMutation, ViewClientsQuery } from '@/lib/gql/__generated__/canonical-documents';
import type {
  OpenClientInput,
  OpenClientMutationMutation,
  ViewClientsQueryQuery,
} from '@/lib/gql/__generated__/graphql';

export const viewClientsActor = fromPromise<ViewClientsQueryQuery['viewClients'], void>(async () => {
  const result = await apolloClient.query({ query: ViewClientsQuery, fetchPolicy: 'no-cache' });
  if (!result.data) throw new Error('Clients could not be loaded.');
  return result.data.viewClients;
});

export const openClientActor = fromPromise<
  OpenClientMutationMutation['openClient'],
  { input: Omit<OpenClientInput, 'clientId'> }
>(async ({ input }) => {
  const result = await apolloClient.mutate({
    mutation: OpenClientMutation,
    variables: {
      input: {
        clientId: crypto.randomUUID(),
        clientName: input.input.clientName,
        fiduciaryName: input.input.fiduciaryName,
      },
    },
  });
  if (!result.data) throw new Error('The Client could not be opened.');
  return result.data.openClient;
});
